import { PropTypes } from 'react';

export default PropTypes.shape({
  subscribe: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/utils/storeShape.js
// module id = 595
// module chunks = 10